export const homeProductsAPI =
  'https://607e95f802a23c0017e8ba2f.mockapi.io/habib-shoplane'

export const getProduct = 'https://5d76bf96515d1a0014085cf9.mockapi.io/product/'
